export var Action;
(function (Action) {
    Action["SING_IN"] = "SING_IN";
    Action["GET_INFO"] = "GET_INFO";
    Action["SING_OUT"] = "SING_OUT";
})(Action || (Action = {}));
